import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randUuid, randBoolean } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer, MirageServer } from './server.js'
import type { PostcodeLookupResponse } from '@/models/address.js'

export type PostcodeResultData = SchemaAttributes<'PostcodeResult'>

export const model = Model as ModelDefinition<PostcodeResultData>

export const factory = Factory.extend<PostcodeResultData>({
  id() {
    return randUuid()
  },
  is_result_available() {
    return randBoolean()
  },
  data() {
    return this.is_result_available
      ? ({
          Latitude: 51.5074,
          Longitude: -0.1278,
          Addresses: [
            '1 High Street, , , , , Sample Town, ',
            '2 High Street, , , , , Sample Town, ',
            '3 High Street, , , , , Sample Town, ',
          ],
        } satisfies PostcodeLookupResponse)
      : undefined
  },
  error() {
    return undefined
  },
})

export function routes(server: MockServer) {
  server.get(
    '/postcodes/results/:task_id',
    function (this: MirageServer, schema, request) {
      const taskId = request.params.task_id

      const fixedData: PostcodeLookupResponse = {
        Latitude: 51.5074,
        Longitude: -0.1278,
        Addresses: [
          '1 High Street, , , , , Sample Town, ',
          '2 High Street, , , , , Sample Town, ',
          '3 High Street, , , , , Sample Town, ',
        ],
      }

      return {
        data: {
          id: taskId,
          type: 'PostcodeResult',
          attributes: {
            is_result_available: true,
            data: fixedData,
            error: undefined,
          },
        },
      }
    },
  )
}
